export const draftDataActionType = {
	DRAFTEDDATA: 'DRAFTEDDATA',
};
